import * as api from '@bob/api-client/latest'
import * as logger from '@bob/logger'
import * as shopify from '@bob/shopify-services'
import * as entity from '@bob/entities'
import * as cold from '@bob/cold-data/client'

const REVIEWS_FETCH_SIZE = 9

export async function get(id: string): Promise<entity.product.Product | null> {
    const productId = shopify.base.shopifyGID(id)
    const shopifyProduct = await shopify.product.get(productId)

    if (
        shopifyProduct === undefined ||
        shopifyProduct.tags.includes('offline') ||
        !shopifyProduct.tags.includes('online')
    ) {
        return null
    }

    const reviews = await getReviews(id, `?limit=${REVIEWS_FETCH_SIZE}`)

    return entity.product.product(id, shopifyProduct, reviews, cold)
}

export async function getReviews(
    id: string,
    next: string
): Promise<api.Paginable<api.ProductReviews> | void> {
    const reviewsResponse = await api.api.get.marketplaceProductReview({
        urlParams: {
            productId: id
        },
        getParams: next
    })

    return reviewsResponse.caseOf({
        left: failure => {
            logger.err(
                `[Product] Unable to get review rewards - Code ${failure.status}`,
                {
                    productId: id,
                    getParams: next,
                    failure
                }
            )
        },
        right: success => {
            return success.body
        }
    })
}

export async function getMediumProductsWithDescription(variables: {
    first: number
    query: string
}): Promise<(entity.product.MediumProduct & { description: string })[]> {
    const products = await shopify.product.getMediumProducts(variables)

    return products.edges.map(edge => ({
        ...entity.product.mediumProduct(edge.node, cold),
        description: edge.node.descriptionHtml
    }))
}
